export enum EConditionPrelevement {
    DesinfectionInf6heures = 1,
    DesinfectionSup6Heures = 2,
    EnSortieDeLaveur = 3,
    EnSortieDuBainDeRincage = 4,
    Autre = 5,
}